import { Label } from "@/components/ui/label";
import { Check, Pipette } from "lucide-react";

const PRESETS = [
  { label: "Transparente", value: "" },
  { label: "Branco", value: "#ffffff" },
  { label: "Preto", value: "#000000" },
];

/** Escolhe a cor de fundo por trás do logótipo do cliente. */
export function LogoBgField({ value = "", onChange }) {
  const isCustom = value && !PRESETS.some((p) => p.value.toLowerCase() === value.toLowerCase());

  return (
    <div>
      <Label className="text-sm">Fundo do logótipo</Label>
      <div className="mt-1.5 flex items-center gap-2">
        {PRESETS.map((preset) => {
          const active = (value || "").toLowerCase() === preset.value.toLowerCase();
          return (
            <button
              key={preset.label}
              type="button"
              title={preset.label}
              onClick={() => onChange(preset.value)}
              className={`relative h-8 w-8 rounded-lg border transition-shadow ${
                active ? "ring-2 ring-primary ring-offset-1" : "border-border hover:border-primary/50"
              } ${preset.value === "" ? "bg-muted" : ""}`}
              style={preset.value ? { backgroundColor: preset.value } : undefined}
            >
              {preset.value === "" && <span className="absolute inset-0 grid place-items-center text-[9px] text-muted-foreground">nada</span>}
              {active && preset.value && (
                <Check className={`absolute inset-0 m-auto h-4 w-4 ${preset.value === "#000000" ? "text-white" : "text-black"}`} />
              )}
            </button>
          );
        })}

        <label
          title="Cor personalizada"
          className={`relative grid h-8 w-8 cursor-pointer place-items-center rounded-lg border transition-shadow ${
            isCustom ? "ring-2 ring-primary ring-offset-1" : "border-border hover:border-primary/50"
          }`}
          style={isCustom ? { backgroundColor: value } : undefined}
        >
          {!isCustom && <Pipette className="h-4 w-4 text-muted-foreground" />}
          <input
            type="color"
            value={isCustom ? value : "#6b4f91"}
            onChange={(e) => onChange(e.target.value)}
            className="absolute inset-0 cursor-pointer opacity-0"
          />
        </label>

        {value && (
          <span className="text-xs text-muted-foreground">{value}</span>
        )}
      </div>
    </div>
  );
}
